import { OpenPositionAgingBucket } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "@/components/filter/_types";
import { FilterComponent } from "@/components/filter/base-filter";
import { JSX } from "react";

export class OpenPositionAgingFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id = "aging";
  readonly labelSingular = "fia:FilterAging";
  readonly labelPlural = "fia:FilterAging";
  readonly placeholder = "fia:FilterAging";
  readonly searchPlaceholder = "common:Search";
  readonly emptyText = "fia:NoOptionFound";
  body = {};
  parameters = {};

  getData(): FilterData {
    return {
      options: [
        { id: OpenPositionAgingBucket.NotDue, name: "fia:AgingNotDue" },
        { id: OpenPositionAgingBucket.Days0To15, name: "fia:Aging0_15" },
        { id: OpenPositionAgingBucket.Days16To30, name: "fia:Aging16_30" },
        { id: OpenPositionAgingBucket.Days31To60, name: "fia:Aging31_60" },
        { id: OpenPositionAgingBucket.Days61To90, name: "fia:Aging61_90" },
        { id: OpenPositionAgingBucket.Days91To120, name: "fia:Aging91_120" },
        { id: OpenPositionAgingBucket.Days121To180, name: "fia:Aging121_180" },
        { id: OpenPositionAgingBucket.Days180Plus, name: "fia:Aging180Plus" },
      ],
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): JSX.Element {
    return <FilterComponent filter={this} {...props} />;
  }
}
